import { Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss']
})
export class InputSelectComponent {
  @Input() label?: string;
  @Input() isRequired = false;
  @Input() value: number = -1;
  @Input() errors?: ValidationErrors | null;

  get errorOutput(): string[] {
    const res: string[] = [];
    if (!this.errors) return res;

    for (const k in this.errors) {
      if (Object.prototype.hasOwnProperty.call(this.errors, k)) {
        const element = this.errors[k];
        if (!!element) res.push(k);
      }
    }

    return res;
  }
}
